import { css } from 'styled-components';
import { ADMIN_COLORS } from '../../theme';

const FORM_TONE = {
  text: '#1a1a22',
  muted: '#8a8a96',
  surface: '#fff',
  border: '#dcdce2',
  borderStrong: '#c9c9d4',
  hover: '#f7f7fa',
  closeHover: '#f2f2f5',
  closeHoverText: '#333',
  secondaryText: '#4a4a55',
  accent: '#4f46e5',
  accentHover: '#4338ca',
  accentActive: '#3730a3',
  accentSoft: '#eef0ff',
  ring: 'rgba(79, 70, 229, 0.25)',
};

const ADMIN_TONE: typeof FORM_TONE = {
  text: ADMIN_COLORS.text,
  muted: ADMIN_COLORS.textMuted,
  surface: ADMIN_COLORS.surface,
  border: ADMIN_COLORS.border,
  borderStrong: ADMIN_COLORS.borderStrong,
  hover: ADMIN_COLORS.hover,
  closeHover: ADMIN_COLORS.hover,
  closeHoverText: ADMIN_COLORS.text,
  secondaryText: ADMIN_COLORS.textSecondary,
  accent: ADMIN_COLORS.accent,
  accentHover: ADMIN_COLORS.accentHover,
  accentActive: ADMIN_COLORS.accentActive,
  accentSoft: ADMIN_COLORS.accentSoft,
  ring: ADMIN_COLORS.accentRing,
};

export const appDialogTone = (admin: boolean) => {
  const tone = admin ? ADMIN_TONE : FORM_TONE;
  return css`
    --dialog-text: ${tone.text};
    --dialog-muted: ${tone.muted};
    --dialog-surface: ${tone.surface};
    --dialog-border: ${tone.border};
    --dialog-border-strong: ${tone.borderStrong};
    --dialog-hover: ${tone.hover};
    --dialog-close-hover: ${tone.closeHover};
    --dialog-close-hover-text: ${tone.closeHoverText};
    --dialog-secondary-text: ${tone.secondaryText};
    --dialog-accent: ${tone.accent};
    --dialog-accent-hover: ${tone.accentHover};
    --dialog-accent-active: ${tone.accentActive};
    --dialog-accent-soft: ${tone.accentSoft};
    --dialog-ring: ${tone.ring};
  `;
};
